import { useRemoteParticipants, useTracks } from '@livekit/components-react';
import { RoomEvent, Track } from 'livekit-client';
import { TranscriptionTile } from './TranscriptionTile';
import { useMemo } from 'react';
import PropTypes from 'prop-types';

function LiveKitSDK({ sendMessage }) {
    const tracks = useTracks(
        [Track.Source.Microphone]
    );

    const participants = useRemoteParticipants({
        updateOnlyOn: [RoomEvent.ParticipantMetadataChanged, RoomEvent.TrackSubscribed]
    });

    const agentParticipant = participants.find((p) => p.isAgent);
    // const isAgentConnected = agentParticipant !== undefined;
    let agentAudioTrack;


    const aat = tracks.find(
        (trackRef) =>
            trackRef.publication.kind === Track.Kind.Audio &&
            trackRef.participant.isAgent
    );
    if (aat) {
        agentAudioTrack = aat;
    } else if (agentParticipant) {
        agentAudioTrack = {
            participant: agentParticipant,
            source: Track.Source.Microphone,
        };
    }
    const chatTileContent = useMemo(() => {
        if (agentAudioTrack) {
            return (
                <TranscriptionTile
                    sendMessage={sendMessage}
                    agentAudioTrack={agentAudioTrack}
                    accentColor={'#FF0000'}
                />
            );
        }
        return <></>;
    }, [agentAudioTrack, sendMessage]);


    return (
        <>
            {chatTileContent}
        </>
    )
}
LiveKitSDK.propTypes = {
    sendMessage: PropTypes.func.isRequired, // Function to send messages to Unity
};
export default LiveKitSDK